
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 5.79A4.482 4.482 0 011.22 4.257a2.193 2.193 0 011.554-.617c.625 0 1.37.273 2.235.82.864.547 1.52.82 1.969.82.442 0 .812-.117 1.109-.351.297-.235.596-.6.898-1.094l.625.422c-.224.463-.578.932-1.062 1.406-.485.469-1.073.703-1.766.703-.666 0-1.43-.273-2.289-.82-.854-.547-1.508-.82-1.96-.82-.381 0-.714.12-1 .359-.287.24-.54.588-.759 1.047l-.609-.344zm0-3.103a4.482 4.482 0 011.055-1.53A2.193 2.193 0 012.773.538c.625 0 1.37.273 2.235.82.864.547 1.52.82 1.969.82.442 0 .812-.116 1.109-.35.297-.235.596-.6.898-1.095l.625.422c-.224.464-.578.933-1.062 1.407-.485.468-1.073.703-1.766.703-.666 0-1.43-.274-2.289-.82-.854-.548-1.508-.821-1.96-.821-.381 0-.714.12-1 .36-.287.239-.54.588-.759 1.046l-.609-.344z","fill":"currentColor"}})])
          )
        }
      }
    